
const TrackingConstants = {
    TRACKING_CONSTANTS: {
        loadMore: {
            name: 'loadMore',
            disabled: false,
            pageSize: 20
        },
        defaultFiltersObj: {
            hubCode: {
                key: "hubCode",
                value: [],
                fieldName: 'c.hubCode'
            },
            pageNumber: 0,
            status: {
                key: "status",
                value: [],
                fieldName: 'c.status'
            },
            dateRange: {
                key: "dateRange",
                value: {
                    startDate: new Date(),
                    endDate: new Date()
                }
            },
        },
        searchAttribute: {
            key: "routeId",
            value: "",
            fieldName: 'c.routeId'
        },
        RESPONSE_CONSTANTS: {
            ERROR_CODES: {
                SESSION_TIMEOUT: "UM100",
                UNAUTHORISED: "UM101",
            }
        },
       DEFAULT_TRANSIT_TIME: "0 Minutes", 
       STATUSES:{
        NEW: "NEW",
        READY_TO_DISPATCH: "READY_TO_DISPATCH",
        PREPARING: "PREPARING",
        PREPARED: "PREPARED",
        OUT_FOR_DELIVERY: "OUT_FOR_DELIVERY",
        ON_HOLD: "ON_HOLD",
        PENDING_DELIVERY: "PENDING_DELIVERY",
        DELIVERED:"DELIVERED",
        PARTIALLY_DELIVERED:"PARTIALLY_DELIVERED",
        CANCELLED:"CANCELLED",
       } ,
       ROUTE_STATUS:{
        CREATED:"CREATED",
        PREPARING:"PREPARING",
        ASSIGNED:"ASSIGNED",
        OUT_FOR_DELIVERY:"OUT_FOR_DELIVERY",
        COMPLETED:"COMPLETED",
        PUBLISHED:"PUBLISHED",
        PREPARED:"PREPARED"
       },
       
    }
}
export default TrackingConstants;